
import BtnReadmore from '~/components/common/btn-readmore.vue'
export default {
  components: {
    BtnReadmore
  },
  props: {
    articles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visibleCount: 8,
      itemsPerLoad: 8
    }
  },
  computed: {
    displayedarticles() {
      return this.articles
      // return this.articles.slice(0, this.visibleCount)
    },
    hasMorearticles() {
      return this.visibleCount < this.articles.length
    }
  },
  methods: {
    loadMorearticles() {
      this.visibleCount += this.itemsPerLoad
    },
    isYouTubeUrl(url) {
      if (!url) {
        return false
      }
      try {
        const u = new URL(url)
        const host = u.hostname.toLowerCase()
        return host.includes('youtube.com') || host.includes('youtu.be')
      } catch (e) {
        return /youtube\.com|youtu\.be/i.test(url)
      }
    }
  }
}
